import { Gender } from "api/resources/global/types"
import { MaritalStatusEnum } from "api/resources/lead/types"

export const genderChoices: {
  label: string
  value: string | number
}[] = [
  { label: "Male", value: Gender.MALE },
  { label: "Female", value: Gender.FEMALE },
  { label: "Prefer not to say", value: Gender.PREFER_NOT_TO_SAY },
]

export const curriculaChoices: {
  label: string
  value: string
}[] = [
  { label: "CBSE", value: "CBSE" },
  { label: "ICSE", value: "ICSE" },
  { label: "Cambridge", value: "Cambridge" },
  { label: "British", value: "British" },
  { label: "American", value: "American" },
  { label: "French", value: "French" },
  { label: "State", value: "State" },
]

export const yearsOfExperienceChoices: {
  label: string
  value: number
}[] = [
  { label: "Less than a year", value: 0 },
  { label: "1 year", value: 1 },
  { label: "2 years", value: 2 },
  { label: "3 years", value: 3 },
  { label: "4 years", value: 4 },
  { label: "5 years", value: 5 },
  { label: "6 years", value: 6 },
  { label: "7 years", value: 7 },
  { label: "8 years", value: 8 },
  { label: "9 years", value: 9 },
  { label: "10 years", value: 10 },
  { label: "11 years", value: 11 },
  { label: "12 years", value: 12 },
  { label: "13 years", value: 13 },
  { label: "14 years", value: 14 },
  { label: "15 years", value: 15 },
  { label: "16 years", value: 16 },
  { label: "17 years", value: 17 },
  { label: "18 years", value: 18 },
  { label: "19 years", value: 19 },
  { label: "20 years", value: 20 },
  { label: "21 years", value: 21 },
  { label: "22 years", value: 22 },
  { label: "23 years", value: 23 },
  { label: "24 years", value: 24 },
  { label: "25 years", value: 25 },
  { label: "26 years", value: 26 },
  { label: "27 years", value: 27 },
  { label: "28 years", value: 28 },
  { label: "29 years", value: 29 },
  { label: "30 years", value: 30 },
  { label: "31 years", value: 31 },
  { label: "32 years", value: 32 },
  { label: "33 years", value: 33 },
  { label: "34 years", value: 34 },
  { label: "35 years", value: 35 },
  { label: "36 years", value: 36 },
  { label: "37 years", value: 37 },
  { label: "38 years", value: 38 },
  { label: "39 years", value: 39 },
  { label: "40 years", value: 40 },
]

export const maritalStatusChoices: {
  label: string
  value: string
}[] = [
  { label: "Unmarried", value: MaritalStatusEnum.UNMARRIED },
  { label: "Married", value: MaritalStatusEnum.MARRIED },
  { label: "Widowed", value: MaritalStatusEnum.WIDOWED },
  { label: "Divorced", value: MaritalStatusEnum.DIVORCED },
]

export enum OutcomeBucketValues {
  PROMOTION_IN_CURRENT_SCHOOL = "Promotion In Current School",
  NEW_JOB_IN_CURRENT_CITY = "New Job In Current City",
  SALARY_RAISE_IN_CURRENT_JOB = "Salary Raise in Current Job",
  TEACH_ABROAD = "Teach Abroad",
  START_TEACHING = "Start Teaching",
}

export const outcomeBucketChoices: {
  label: string
  value: OutcomeBucketValues
}[] = [
  {
    label: "Promotion In Current School",
    value: OutcomeBucketValues.PROMOTION_IN_CURRENT_SCHOOL,
  },
  {
    label: "New Job In Current City",
    value: OutcomeBucketValues.NEW_JOB_IN_CURRENT_CITY,
  },
  {
    label: "Salary Raise in Current Job",
    value: OutcomeBucketValues.SALARY_RAISE_IN_CURRENT_JOB,
  },
  { label: "Teach Abroad", value: OutcomeBucketValues.TEACH_ABROAD },
  { label: "Start Teaching", value: OutcomeBucketValues.START_TEACHING },
]

export const targetCountryChoices: {
  label: string
  value: string
}[] = [
  { label: "UAE", value: "UAE" },
  { label: "USA", value: "USA" },
  { label: "Open To All", value: "Open To All" },
]
